function fn_wsw() {
    var $this = $(".part_ui_wsw");
    $this.find("table").each(function() {
       $(this).wrap("<div class='table'></div>");
    });
}